import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import PropTypes from 'prop-types';

const ProposalStatusIcon = ({ isGenerated }) => {
    if (isGenerated)
        return <CircleIcon fontSize="medium" sx={{ color: '#3caf5f' }} />;
    return <CircleIcon fontSize="medium" sx={{ color: '#f57d00' }} />;
};

ProposalStatusIcon.propTypes = {
    isGenerated: PropTypes.bool,
};

export default ProposalStatusIcon;
